(function () {
  function init(directory) {
    if (directory.dataset.directoryReady === 'true') return;
    const list = directory.querySelector('[data-directory-list]');
    const search = directory.querySelector('[data-directory-search]');
    const letters = directory.querySelector('[data-directory-letters]');
    const count = directory.querySelector('[data-directory-count]');
    const empty = directory.querySelector('[data-directory-empty]');
    if (!list || !search || !letters || !count || !empty) return;

    const items = Array.from(list.querySelectorAll('li')).filter((item) => item.querySelector('a'));
    items.sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim(), undefined, { sensitivity: 'base' }));
    items.forEach((item) => list.appendChild(item));
    const entries = items.map((item) => {
      const name = item.textContent.trim();
      const first = name[0] ? name[0].toUpperCase() : '#';
      return { item, name: name.toLocaleLowerCase(), letter: /[A-Z]/.test(first) ? first : '#' };
    });
    const available = new Set(entries.map((entry) => entry.letter));
    let activeLetter = 'All';

    function addLetter(label) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.setAttribute('aria-pressed', label === 'All' ? 'true' : 'false');
      button.addEventListener('click', () => {
        activeLetter = label;
        search.value = '';
        update();
      });
      letters.appendChild(button);
    }
    addLetter('All');
    ['#', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'].forEach((letter) => { if (available.has(letter)) addLetter(letter); });

    function update() {
      const query = search.value.trim().toLocaleLowerCase();
      let visible = 0;
      entries.forEach(({ item, name, letter }) => {
        const match = (activeLetter === 'All' || letter === activeLetter) && name.includes(query);
        item.hidden = !match;
        if (match) visible += 1;
      });
      letters.querySelectorAll('button').forEach((button) => button.setAttribute('aria-pressed', String(button.textContent === activeLetter)));
      count.textContent = `Showing ${visible} of ${entries.length} ${directory.dataset.directoryLabel || 'items'}`;
      empty.hidden = visible !== 0;
    }
    search.addEventListener('input', () => { activeLetter = 'All'; update(); });
    search.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { search.value = ''; activeLetter = 'All'; update(); }
    });
    directory.dataset.directoryReady = 'true';
    update();
  }

  function initAll(root) {
    root.querySelectorAll('[data-wholesale-directory]').forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
